import axios from "axios";
import { defaultHeader } from "../constants/defaultItems";
import { toast } from "@/components/ui/use-toast";

export const getPaymentMethods = (includeManual, callback) => (dispatch) => {
  axios.get('/api/Payment/GetPaymentGateway?includeManual=' + includeManual, defaultHeader)
    .then(function (resp) {
      if (resp.status == 200) {
        callback && callback(resp.data);
      }
    }).catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message
      })
    })
}
export const continueFromPayment = (payload, callback) => (dispatch) => {
  axios.post('/api/Payment/RequestPayment', payload, defaultHeader)
    .then(function (resp) {
      if (resp.status == 200) {
        callback && callback(resp.data);
      }
    }).catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message
      })
    })
}
export const getReservation = (bookCode, readOnly = false, callback) => (dispatch) => {
  axios.get(`/api/IntFlight/GetReservation?BookingRef=${bookCode}&tranID=${localStorage.transId ?? ""}&readOnly=${readOnly}`, defaultHeader)
    .then(function (resp) {
      if (resp.data.IsSuccess) {
        callback && callback(resp.data);
      }
      else {
        toast({
          variant: "destructive",
          title: "Error",
          description: resp.data?.Message ?? "Failed to fetch reservation"
        })
        callback && callback(null);
      }
    }).catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message
      })
    })
}

export const requestTourPayment = (payload, callback) => (dispatch) => {
  axios.post('/api/Payment/RequestTourPayment', payload, defaultHeader)
    .then(function (resp) {
      if (resp.status === 200) {
        callback && callback(resp.data);
      }
    }).catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message
      })
    })
}